import { useState, useEffect, useRef } from "react";

const API = "/api/superadmin";
let _t = sessionStorage.getItem("sa_token") || "";
const h = () => ({ Authorization: `Bearer ${_t}` });
const sa = {
  get:   (u)    => fetch(API+u,{headers:h()}).then(r=>r.json()),
  post:  (u,d)  => fetch(API+u,{method:"POST",headers:{...h(),"Content-Type":"application/json"},body:JSON.stringify(d)}).then(r=>r.json()),
  patch: (u,d)  => fetch(API+u,{method:"PATCH",headers:{...h(),"Content-Type":"application/json"},body:JSON.stringify(d)}).then(r=>r.json()),
};
const fmt = n => "₹" + Number(n).toLocaleString("en-IN");
const Pill = ({t,c}) => <span style={{display:"inline-block",padding:"2px 10px",borderRadius:20,
  fontSize:12,fontWeight:600,background:c==="green"?"#DCFCE7":c==="red"?"#FEE2E2":c==="blue"?"#DBEAFE":c==="orange"?"#FEF3C7":"#EDE9FE",
  color:c==="green"?"#166534":c==="red"?"#991B1B":c==="blue"?"#1D4ED8":c==="orange"?"#92400e":"#5B21B6"}}>{t}</span>;

// ── Login ──────────────────────────────────────────────────────────────────
function Login({onLogin}){
  const [u,setU]=useState(""),[p,setP]=useState(""),[err,setErr]=useState("");
  const go = async e => {
    e.preventDefault();
    const r = await fetch(API+"/login",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({username:u,password:p})}).then(r=>r.json());
    if(r.token){ _t=r.token; sessionStorage.setItem("sa_token",r.token); onLogin(r); }
    else setErr(r.detail||"Login failed");
  };
  return <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#0F172A"}}>
    <div style={{background:"#1E293B",borderRadius:16,padding:"44px 40px",width:400,boxShadow:"0 8px 40px rgba(0,0,0,.4)"}}>
      <div style={{textAlign:"center",marginBottom:32}}>
        <div style={{fontSize:24,fontWeight:800,color:"#F8FAFC",letterSpacing:".2em"}}>INVINCIBLE</div>
        <div style={{fontSize:12,color:"#475569",marginTop:6,letterSpacing:".12em",textTransform:"uppercase"}}>Platform Admin</div>
      </div>
      <form onSubmit={go}>
        {[["Username",u,setU,"text"],["Password",p,setP,"password"]].map(([l,v,s,t])=>(
          <div key={l} style={{marginBottom:16}}>
            <label style={{display:"block",fontSize:12,color:"#94A3B8",marginBottom:6,textTransform:"uppercase",letterSpacing:".05em"}}>{l}</label>
            <input type={t} value={v} onChange={e=>s(e.target.value)} required
              style={{width:"100%",padding:"12px 14px",borderRadius:9,border:"1px solid #334155",background:"#0F172A",color:"#F8FAFC",fontSize:14,boxSizing:"border-box"}}/>
          </div>
        ))}
        {err&&<div style={{color:"#F87171",fontSize:13,marginBottom:12,padding:"8px 12px",background:"rgba(239,68,68,.1)",borderRadius:7}}>{err}</div>}
        <button type="submit" style={{width:"100%",padding:13,borderRadius:9,border:"none",background:"#0D9488",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer",marginTop:4}}>Sign In</button>
      </form>
    </div>
  </div>;
}

// ── Add Company Modal ──────────────────────────────────────────────────────
function AddModal({onClose,onDone}){
  const [step,setStep]=useState(1);
  const [cmp,setCmp]=useState(null);
  const [msg,setMsg]=useState("");
  const [logo,setLogo]=useState(null);
  const [f,setF]=useState({name:"",code:"",email:"",phone:"",plan:"growth",max_seats:10,price_per_seat:50,trial_days:30,notes:""});
  const [af,setAf]=useState({employee_id:"",first_name:"",last_name:"",email:"",password:""});

  const inp = {style:{width:"100%",padding:"10px 12px",borderRadius:8,border:"1px solid #E2E8F0",fontSize:14,boxSizing:"border-box",fontFamily:"inherit"}};
  const label = txt => <label style={{fontSize:12,color:"#64748B",display:"block",marginBottom:5,fontWeight:600,textTransform:"uppercase",letterSpacing:".04em"}}>{txt}</label>;

  const go1 = async () => {
    if(!f.name||!f.code){ setMsg("Name and code required."); return; }
    setMsg("Creating…");
    const r = await sa.post("/companies",f);
    if(!r.ok){ setMsg(r.detail||"Error"); return; }
    // Upload logo if selected
    if(logo){
      const fd=new FormData(); fd.append("logo",logo);
      await fetch(`${API}/companies/${r.company.id}/logo/upload`,{method:"POST",headers:h(),body:fd});
    }
    setCmp(r.company); setStep(2); setMsg("");
  };

  const go2 = async () => {
    if(!af.employee_id||!af.email){ setMsg("Employee ID and email required."); return; }
    setMsg("Creating admin…");
    const r = await sa.post(`/companies/${cmp.id}/admin`,{...af,password:af.password||af.employee_id});
    if(r.ok){ setMsg("✓ Done! Company is ready."); onDone(); setTimeout(onClose,1500); }
    else setMsg(r.detail||"Error");
  };

  return <div onClick={e=>e.target===e.currentTarget&&onClose()}
    style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div style={{background:"#fff",borderRadius:16,maxWidth:560,width:"100%",maxHeight:"92vh",overflow:"auto",boxShadow:"0 8px 40px rgba(0,0,0,.25)"}}>
      {/* Header */}
      <div style={{padding:"20px 26px",borderBottom:"1px solid #F1F5F9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <h2 style={{margin:0,fontSize:18,fontWeight:700}}>{step===1?"New Client Company":"Create Admin User"}</h2>
          <div style={{fontSize:12,color:"#94A3B8",marginTop:3}}>Step {step} of 2</div>
        </div>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:26,cursor:"pointer",color:"#CBD5E1",lineHeight:1}}>×</button>
      </div>
      <div style={{padding:"22px 26px"}}>
        {step===1&&<div style={{display:"grid",gap:14}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 110px",gap:12}}>
            <div>{label("Company Name *")}<input {...inp} value={f.name} onChange={e=>setF({...f,name:e.target.value})} placeholder="Acme Technologies"/></div>
            <div>{label("Code *")}<input {...inp} value={f.code} onChange={e=>setF({...f,code:e.target.value.toUpperCase().replace(/\s/g,"")})} placeholder="ACME" style={{...inp.style,textTransform:"uppercase",letterSpacing:".08em"}}/></div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div>{label("Email *")}<input {...inp} type="email" value={f.email} onChange={e=>setF({...f,email:e.target.value})}/></div>
            <div>{label("Phone")}<input {...inp} value={f.phone} onChange={e=>setF({...f,phone:e.target.value})}/></div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            <div>{label("Plan")}<select {...inp} value={f.plan} onChange={e=>setF({...f,plan:e.target.value})}>
              <option value="starter">Starter</option><option value="growth">Growth</option><option value="pro">Pro</option>
            </select></div>
            <div>{label("Licenses (max users)")}<input {...inp} type="number" min={1} value={f.max_seats} onChange={e=>setF({...f,max_seats:+e.target.value})}/></div>
            <div>{label("₹ per user/month")}<input {...inp} type="number" min={0} value={f.price_per_seat} onChange={e=>setF({...f,price_per_seat:+e.target.value})}/></div>
          </div>
          <div>{label("Trial Days (access valid for)")}<input {...inp} type="number" min={1} value={f.trial_days} onChange={e=>setF({...f,trial_days:+e.target.value})}/></div>
          <div>{label("Notes / Contact Info")}<textarea {...inp} rows={2} value={f.notes} onChange={e=>setF({...f,notes:e.target.value})}/></div>
          {/* Logo upload */}
          <div>
            {label("Company Logo (shown on login page)")}
            <div style={{display:"flex",gap:12,alignItems:"center"}}>
              <label style={{cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6,
                background:"#F0FDF4",border:"1.5px dashed #0D9488",borderRadius:8,padding:"9px 16px",fontSize:13,color:"#0D9488",fontWeight:600}}>
                🖼 Choose Logo
                <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>setLogo(e.target.files[0])}/>
              </label>
              {logo&&<><img src={URL.createObjectURL(logo)} alt="" style={{height:40,borderRadius:6,objectFit:"contain",border:"1px solid #E2E8F0"}}/><span style={{fontSize:12,color:"#64748B"}}>{logo.name}</span></>}
            </div>
            <div style={{fontSize:11,color:"#94A3B8",marginTop:4}}>PNG or JPG, max 2MB. Shown on employee login page.</div>
          </div>
          <div style={{padding:"12px 16px",background:"#F0FDF4",borderRadius:10,fontSize:13,color:"#166534",display:"flex",justifyContent:"space-between"}}>
            <span>Max monthly bill: <b>{fmt(f.max_seats*f.price_per_seat)}</b></span>
            <span>Login URL: <b>team.invincibleweb.in/{f.code.toLowerCase()||"code"}/</b></span>
          </div>
          {msg&&<div style={{fontSize:13,color:msg.includes("✓")?"#166534":"#DC2626",padding:"10px 14px",background:msg.includes("✓")?"#DCFCE7":"#FEE2E2",borderRadius:8}}>{msg}</div>}
          <button onClick={go1} style={{padding:13,borderRadius:9,border:"none",background:"#0D9488",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer"}}>Create Company →</button>
        </div>}

        {step===2&&<div style={{display:"grid",gap:14}}>
          <div style={{padding:"14px 18px",background:"#DCFCE7",borderRadius:10,fontSize:14,color:"#166534",fontWeight:500}}>
            ✓ <b>{cmp?.name}</b> created!<br/>
            <span style={{fontSize:12,color:"#4ADE80"}}>Login URL: team.invincibleweb.in/{cmp?.code?.toLowerCase()}/login</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div>{label("Employee ID *")}<input {...inp} value={af.employee_id} onChange={e=>setAf({...af,employee_id:e.target.value.toUpperCase()})} placeholder="EMP001"/></div>
            <div>{label("Password (blank = Employee ID)")}<input {...inp} value={af.password} onChange={e=>setAf({...af,password:e.target.value})} placeholder="Leave blank to use Employee ID"/></div>
            <div>{label("First Name")}<input {...inp} value={af.first_name} onChange={e=>setAf({...af,first_name:e.target.value})}/></div>
            <div>{label("Last Name")}<input {...inp} value={af.last_name} onChange={e=>setAf({...af,last_name:e.target.value})}/></div>
          </div>
          <div>{label("Email *")}<input {...inp} type="email" value={af.email} onChange={e=>setAf({...af,email:e.target.value})}/></div>
          {msg&&<div style={{fontSize:13,color:msg.includes("✓")?"#166534":"#DC2626",padding:"10px 14px",background:msg.includes("✓")?"#DCFCE7":"#FEE2E2",borderRadius:8}}>{msg}</div>}
          <button onClick={go2} style={{padding:13,borderRadius:9,border:"none",background:"#0D9488",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer"}}>✓ Create Admin & Finish</button>
        </div>}
      </div>
    </div>
  </div>;
}


const ALL_FEATURES = [
  {key:"checkin",      label:"Check In/Out",   desc:"Face check-in and check-out"},
  {key:"attendance",   label:"Attendance",      desc:"Monthly attendance calendar"},
  {key:"history",      label:"History",         desc:"Face recognition history logs"},
  {key:"leaves",       label:"Leaves",          desc:"Leave requests and balances"},
  {key:"timesheet",    label:"Timesheet",       desc:"Daily timesheet logging"},
  {key:"team",         label:"Team",            desc:"Team management view"},
  {key:"direct_call",  label:"Direct Call",     desc:"Direct call feature"},
  {key:"reports",      label:"Reports",         desc:"Reports and exports"},
];

function FeatureToggles({c, onSave}){
  const base = c.features || {};
  const [feats, setFeats] = useState({...base});
  const [msg,   setMsg  ] = useState("");

  const toggle = k => setFeats(f=>({...f,[k]:!f[k]}));

  return <div style={{padding:"16px",background:"#F8FAFC",borderRadius:12,border:"1px solid #E2E8F0",marginBottom:16}}>
    <div style={{fontSize:13,fontWeight:700,color:"#1E293B",marginBottom:4}}>⚙ Feature Access Control</div>
    <div style={{fontSize:12,color:"#94A3B8",marginBottom:14}}>Toggle which modules this company can access. Overrides plan defaults.</div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
      {ALL_FEATURES.map(({key,label,desc})=>(
        <div key={key} onClick={()=>toggle(key)}
          style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",
            borderRadius:9,cursor:"pointer",transition:"all .12s",
            background:feats[key]?"#F0FDF4":"#FEF2F2",
            border:`1px solid ${feats[key]?"#86EFAC":"#FCA5A5"}`}}>
          <div style={{width:36,height:20,borderRadius:10,position:"relative",flexShrink:0,
            background:feats[key]?"#0D9488":"#E2E8F0",transition:"background .2s"}}>
            <div style={{position:"absolute",top:2,left:feats[key]?18:2,width:16,height:16,
              borderRadius:"50%",background:"#fff",transition:"left .2s",boxShadow:"0 1px 3px rgba(0,0,0,.2)"}}/>
          </div>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:feats[key]?"#166534":"#991B1B"}}>{label}</div>
            <div style={{fontSize:11,color:"#94A3B8"}}>{desc}</div>
          </div>
        </div>
      ))}
    </div>
    <div style={{display:"flex",gap:10,alignItems:"center"}}>
      <button onClick={()=>onSave(feats)}
        style={{padding:"9px 22px",borderRadius:8,border:"none",background:"#0D9488",color:"#fff",fontWeight:600,cursor:"pointer",fontSize:13}}>
        Save Feature Access
      </button>
      <button onClick={()=>setFeats({...ALL_FEATURES.reduce((a,{key})=>({...a,[key]:true}),{})})}
        style={{padding:"9px 14px",borderRadius:8,border:"1px solid #E2E8F0",background:"#fff",color:"#64748B",cursor:"pointer",fontSize:12}}>
        Enable All
      </button>
      <button onClick={()=>setFeats({...ALL_FEATURES.reduce((a,{key})=>({...a,[key]:false}),{})})}
        style={{padding:"9px 14px",borderRadius:8,border:"1px solid #E2E8F0",background:"#fff",color:"#64748B",cursor:"pointer",fontSize:12}}>
        Disable All
      </button>
    </div>
  </div>;
}



function EmpProfileModal({emp, companyId, onClose, onSaved}){
  const [f, setF] = useState({...emp, password:""});
  const [msg, setMsg] = useState("");

  const save = async () => {
    setMsg("Saving…");
    // Update via reset-password if password given
    if(f.password) {
      const r = await sa.post(`/companies/${companyId}/employees/${emp.employee_id}/reset-password`, {password:f.password});
      if(!r.ok){setMsg(r.detail||"Error");return;}
    }
    setMsg("✓ Saved");
    onSaved();
    setTimeout(onClose, 1200);
  };

  const inp = {style:{width:"100%",padding:"9px 12px",borderRadius:8,border:"1px solid #E2E8F0",fontSize:14,boxSizing:"border-box"}};
  const lbl = t => <label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:".04em"}}>{t}</label>;

  return <div onClick={e=>e.target===e.currentTarget&&onClose()}
    style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:10000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div style={{background:"#fff",borderRadius:14,maxWidth:480,width:"100%",boxShadow:"0 8px 40px rgba(0,0,0,.25)"}}>
      <div style={{padding:"18px 24px",borderBottom:"1px solid #F1F5F9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{fontWeight:700,fontSize:17}}>{emp.name||emp.employee_id}</div>
          <div style={{fontSize:12,color:"#94A3B8"}}>{emp.employee_id} · {emp.email}</div>
        </div>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:"#CBD5E1"}}>×</button>
      </div>
      <div style={{padding:"20px 24px",display:"grid",gap:14}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div>{lbl("First Name")}<input {...inp} value={f.first_name||""} onChange={e=>setF({...f,first_name:e.target.value})}/></div>
          <div>{lbl("Last Name")}<input {...inp} value={f.last_name||""} onChange={e=>setF({...f,last_name:e.target.value})}/></div>
        </div>
        <div>{lbl("Email")}<input {...inp} type="email" value={f.email||""} onChange={e=>setF({...f,email:e.target.value})}/></div>
        <div>{lbl("Role")}
          <select {...inp} value={f.role||"team_member"} onChange={e=>setF({...f,role:e.target.value})}>
            <option value="admin">Admin</option>
            <option value="hr">HR</option>
            <option value="manager">Manager</option>
            <option value="team_member">Team Member</option>
          </select>
        </div>
        <div style={{padding:"12px 14px",background:"#FFF7ED",borderRadius:8,border:"1px solid #FED7AA"}}>
          {lbl("Reset Password (leave blank to keep current)")}
          <input {...inp} type="password" value={f.password} placeholder="New password…"
            onChange={e=>setF({...f,password:e.target.value})}
            style={{...inp.style,marginTop:4}}/>
        </div>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <span style={{padding:"4px 12px",borderRadius:20,fontSize:12,fontWeight:600,
            background:emp.is_active?"#DCFCE7":"#FEE2E2",color:emp.is_active?"#166534":"#991B1B"}}>
            {emp.is_active?"Active":"Inactive"}
          </span>
          <span style={{padding:"4px 12px",borderRadius:20,fontSize:12,fontWeight:600,
            background:emp.face_enrolled?"#DCFCE7":"#F1F5F9",color:emp.face_enrolled?"#166534":"#94A3B8"}}>
            {emp.face_enrolled?"✓ Face enrolled":"No face"}
          </span>
        </div>
        {msg&&<div style={{padding:"10px 14px",borderRadius:8,fontSize:13,fontWeight:500,
          background:msg.includes("✓")?"#DCFCE7":"#FEE2E2",color:msg.includes("✓")?"#166534":"#DC2626"}}>{msg}</div>}
        <button onClick={save}
          style={{padding:12,borderRadius:9,border:"none",background:"#0D9488",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer"}}>
          Save Changes
        </button>
      </div>
    </div>
  </div>;
}

function EmployeesSection({c}){
  const [emps,  setEmps]  = useState([]);
  const [loading,setLoad] = useState(true);
  const [pwMap, setPwMap] = useState({});  // emp_id -> new password input
  const [msgs,  setMsgs]  = useState({});  // emp_id -> message
  const [showAddEmp, setShowAddEmp] = useState(false);
  const [newEmp, setNewEmp] = useState({employee_id:"",first_name:"",last_name:"",email:"",role:"team_member",password:""});
  const [addMsg, setAddMsg] = useState("");
  const [selectedEmp, setSelectedEmp] = useState(null);

  useEffect(()=>{
    sa.get(`/companies/${c.id}/employees`)
      .then(d=>setEmps(d.employees||[]))
      .catch(()=>{})
      .finally(()=>setLoad(false));
  },[c.id]);

  const resetPw = async(emp) => {
    const pw = pwMap[emp.employee_id]||"";
    const r = await sa.post(
      `/companies/${c.id}/employees/${emp.employee_id}/reset-password`,
      {password: pw||emp.employee_id}
    );
    setMsgs(m=>({...m,[emp.employee_id]: r.ok ? `✓ Reset to "${pw||emp.employee_id}"` : r.detail||"Error"}));
    setPwMap(m=>({...m,[emp.employee_id]:""}));
  };

  const ROLE_COLOR = {admin:"#5B21B6",hr:"#1D4ED8",manager:"#92400E",team_member:"#166534"};

  return <div style={{padding:"16px",background:"#F8FAFC",borderRadius:12,border:"1px solid #E2E8F0",marginBottom:16}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
      <div style={{fontSize:13,fontWeight:700,color:"#1E293B"}}>👥 Employees ({emps.length}/{c.max_seats} seats used)</div>
      <button onClick={()=>setShowAddEmp(!showAddEmp)}
        style={{padding:"6px 14px",borderRadius:7,border:"none",background:"#0D9488",
          color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        {showAddEmp?"Cancel":"+ Add Employee"}
      </button>
    </div>
    <div style={{fontSize:12,color:"#94A3B8",marginBottom:14}}>Manage and reset passwords for company employees.</div>
    {showAddEmp&&<div style={{padding:"14px",background:"#F0FDF4",borderRadius:10,border:"1px solid #D1FAE5",marginBottom:14}}>
      <div style={{fontSize:13,fontWeight:600,color:"#166534",marginBottom:10}}>Add New Employee</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:8}}>
        <div><label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:3}}>Employee ID *</label>
          <input value={newEmp.employee_id} onChange={e=>setNewEmp({...newEmp,employee_id:e.target.value.toUpperCase()})}
            placeholder="EMP001" style={{width:"100%",padding:"7px 10px",borderRadius:7,border:"1px solid #E2E8F0",fontSize:13,boxSizing:"border-box"}}/></div>
        <div><label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:3}}>First Name</label>
          <input value={newEmp.first_name} onChange={e=>setNewEmp({...newEmp,first_name:e.target.value})}
            style={{width:"100%",padding:"7px 10px",borderRadius:7,border:"1px solid #E2E8F0",fontSize:13,boxSizing:"border-box"}}/></div>
        <div><label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:3}}>Last Name</label>
          <input value={newEmp.last_name} onChange={e=>setNewEmp({...newEmp,last_name:e.target.value})}
            style={{width:"100%",padding:"7px 10px",borderRadius:7,border:"1px solid #E2E8F0",fontSize:13,boxSizing:"border-box"}}/></div>
        <div><label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:3}}>Email *</label>
          <input type="email" value={newEmp.email} onChange={e=>setNewEmp({...newEmp,email:e.target.value})}
            style={{width:"100%",padding:"7px 10px",borderRadius:7,border:"1px solid #E2E8F0",fontSize:13,boxSizing:"border-box"}}/></div>
        <div><label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:3}}>Role</label>
          <select value={newEmp.role} onChange={e=>setNewEmp({...newEmp,role:e.target.value})}
            style={{width:"100%",padding:"7px 10px",borderRadius:7,border:"1px solid #E2E8F0",fontSize:13,boxSizing:"border-box"}}>
            <option value="admin">Admin</option>
            <option value="hr">HR</option>
            <option value="manager">Manager</option>
            <option value="team_member">Team Member</option>
          </select></div>
        <div><label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:3}}>Password (blank=EmpID)</label>
          <input value={newEmp.password} onChange={e=>setNewEmp({...newEmp,password:e.target.value})}
            placeholder="Leave blank to use Employee ID"
            style={{width:"100%",padding:"7px 10px",borderRadius:7,border:"1px solid #E2E8F0",fontSize:13,boxSizing:"border-box"}}/></div>
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        <button onClick={async()=>{
          if(!newEmp.employee_id||!newEmp.email){setAddMsg("ID and email required.");return;}
          setAddMsg("Creating…");
          const r=await sa.post(`/companies/${c.id}/admin`,{...newEmp,password:newEmp.password||newEmp.employee_id});
          if(r.ok){setAddMsg("✓ Employee added!");setNewEmp({employee_id:"",first_name:"",last_name:"",email:"",role:"team_member",password:""});
            sa.get(`/companies/${c.id}/employees`).then(d=>setEmps(d.employees||[]));}
          else setAddMsg(r.detail||"Error");
        }} style={{padding:"8px 18px",borderRadius:7,border:"none",background:"#0D9488",color:"#fff",fontWeight:600,cursor:"pointer",fontSize:13}}>
          Add Employee
        </button>
        {addMsg&&<span style={{fontSize:12,color:addMsg.includes("✓")?"#166534":"#DC2626"}}>{addMsg}</span>}
      </div>
    </div>}
    {loading?<div style={{color:"#94A3B8",fontSize:13}}>Loading…</div>:
    emps.length===0?<div style={{color:"#94A3B8",fontSize:13}}>No employees yet.</div>:(
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
        <thead><tr style={{borderBottom:"2px solid #E2E8F0"}}>
          {["ID","Name","Role","Status","New Password",""].map(h=>(
            <th key={h} style={{padding:"8px 10px",textAlign:"left",fontSize:11,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:".05em"}}>{h}</th>
          ))}
        </tr></thead>
        <tbody>{emps.map(emp=>(
          <tr key={emp.employee_id} onClick={()=>setSelectedEmp(emp)}
              style={{borderBottom:"1px solid #F1F5F9",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.background="#F0FDF4"}
              onMouseLeave={e=>e.currentTarget.style.background=""}>
            <td style={{padding:"9px 10px",fontWeight:700,color:"#0D9488"}}>{emp.employee_id}</td>
            <td style={{padding:"9px 10px"}}>{emp.name}<br/><span style={{fontSize:11,color:"#94A3B8"}}>{emp.email}</span></td>
            <td style={{padding:"9px 10px"}}>
              <span style={{padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:600,
                background:"#EDE9FE",color:ROLE_COLOR[emp.role]||"#64748B"}}>{emp.role}</span>
            </td>
            <td style={{padding:"9px 10px"}}>
              <span style={{padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:600,
                background:emp.is_active?"#DCFCE7":"#FEE2E2",
                color:emp.is_active?"#166534":"#991B1B"}}>{emp.is_active?"Active":"Inactive"}</span>
            </td>
            <td style={{padding:"9px 10px"}}>
              <input value={pwMap[emp.employee_id]||""} 
                onChange={e=>setPwMap(m=>({...m,[emp.employee_id]:e.target.value}))}
                placeholder={`Blank = reset to ${emp.employee_id}`}
                style={{padding:"6px 10px",borderRadius:7,border:"1px solid #E2E8F0",fontSize:12,width:"180px"}}/>
            </td>
            <td style={{padding:"9px 10px"}}>
              <button onClick={()=>resetPw(emp)}
                style={{padding:"6px 14px",borderRadius:7,border:"none",background:"#0D9488",
                  color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
                Reset Password
              </button>
              {msgs[emp.employee_id]&&(
                <div style={{fontSize:11,marginTop:3,color:msgs[emp.employee_id].includes("✓")?"#166534":"#DC2626"}}>
                  {msgs[emp.employee_id]}
                </div>
              )}
            </td>
          </tr>
        ))}</tbody>
      </table>
    )}
  {selectedEmp&&<EmpProfileModal
      emp={selectedEmp}
      companyId={c.id}
      onClose={()=>setSelectedEmp(null)}
      onSaved={()=>{ sa.get(`/companies/${c.id}/employees`).then(d=>setEmps(d.employees||[])); setSelectedEmp(null); }}
    />}
  </div>;
}

// ── Company Detail Panel ───────────────────────────────────────────────────
function CompanyDetail({c,onClose,onRefresh}){
  const [seats,  setSeats]   = useState(c.max_seats);
  const [price,  setPrice]   = useState(c.price_per_seat);
  const [extDate,setExtDate] = useState("");
  const [msg,    setMsg]     = useState("");
  const [logo,   setLogo]    = useState(null);

  const save = async (patch) => {
    setMsg("Saving…");
    const r = await sa.patch(`/companies/${c.id}`, patch);
    if(r.ok){ setMsg("✓ Saved"); onRefresh(); } else setMsg(r.detail||"Error");
  };

  const extend = async () => {
    setMsg("Extending…");
    const r = await sa.patch(`/companies/${c.id}`,{valid_until:extDate,is_active:true});
    if(r.ok){ setMsg(`✓ Valid until ${r.valid_until}`); onRefresh(); } else setMsg(r.detail||"Error");
  };

  const uploadLogo = async () => {
    if(!logo) return;
    setMsg("Uploading logo…");
    const fd=new FormData(); fd.append("logo",logo);
    const r=await fetch(`${API}/companies/${c.id}/logo/upload`,{method:"POST",headers:h(),body:fd}).then(r=>r.json());
    if(r.ok){ setMsg("✓ Logo updated"); onRefresh(); } else setMsg("Logo upload failed");
  };

  const inp = s => ({style:{padding:"9px 12px",borderRadius:8,border:"1px solid #E2E8F0",fontSize:14,boxSizing:"border-box",width:"100%",...s}});

  return <div style={{background:"#fff",border:"1px solid #E2E8F0",borderRadius:14,padding:"24px 28px",marginTop:16}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
      <div style={{display:"flex",gap:14,alignItems:"center"}}>
        {c.has_logo&&<img src={`${c.logo_url}?t=${Date.now()}`} alt="" style={{height:44,objectFit:"contain",borderRadius:8,border:"1px solid #E2E8F0"}}/>}
        <div>
          <h3 style={{margin:0,fontSize:18,fontWeight:700}}>{c.name}</h3>
          <div style={{fontSize:13,color:"#64748B"}}>Code: <b style={{color:"#0D9488"}}>{c.code}</b> · Login: <a href={`/${c.code.toLowerCase()}/login`} target="_blank" rel="noreferrer" style={{color:"#0D9488"}}>team.invincibleweb.in/{c.code.toLowerCase()}/login</a></div>
        </div>
      </div>
      <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:"#CBD5E1"}}>×</button>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:20}}>
      {[
        ["Seats Used", `${c.seats_used} / ${c.max_seats}`, c.seats_available===0?"#DC2626":"#166534"],
        ["Monthly Bill", fmt(c.monthly_bill), "#0D9488"],
        ["Days Left", c.days_left!=null?`${c.days_left} days`:"∞", c.days_left<=7?"#DC2626":c.days_left<=30?"#D97706":"#166534"],
      ].map(([l,v,col])=>(
        <div key={l} style={{padding:"12px 16px",background:"#F8FAFC",borderRadius:10}}>
          <div style={{fontSize:11,color:"#94A3B8",textTransform:"uppercase",letterSpacing:".06em",marginBottom:4}}>{l}</div>
          <div style={{fontSize:20,fontWeight:700,color:col}}>{v}</div>
        </div>
      ))}
    </div>

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
      {/* License management */}
      <div style={{padding:"16px",background:"#F8FAFC",borderRadius:12,border:"1px solid #E2E8F0"}}>
        <div style={{fontSize:13,fontWeight:700,color:"#1E293B",marginBottom:12}}>🪑 License Management</div>
        <div style={{marginBottom:10}}>
          <label style={{fontSize:12,color:"#64748B",display:"block",marginBottom:4}}>Max Users (licenses)</label>
          <input {...inp()} type="number" min={c.seats_used} value={seats} onChange={e=>setSeats(+e.target.value)}/>
          <div style={{fontSize:11,color:"#94A3B8",marginTop:3}}>Currently using {c.seats_used} seats</div>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,color:"#64748B",display:"block",marginBottom:4}}>₹ per user / month</label>
          <input {...inp()} type="number" min={0} value={price} onChange={e=>setPrice(+e.target.value)}/>
          <div style={{fontSize:11,color:"#94A3B8",marginTop:3}}>New bill: {fmt(seats*price)}/mo</div>
        </div>
        <button onClick={()=>save({max_seats:seats,price_per_seat:price})}
          style={{width:"100%",padding:"9px",borderRadius:8,border:"none",background:"#0D9488",color:"#fff",fontWeight:600,cursor:"pointer",fontSize:13}}>
          Update Licenses
        </button>
      </div>

      {/* Subscription */}
      <div style={{padding:"16px",background:"#F8FAFC",borderRadius:12,border:"1px solid #E2E8F0"}}>
        <div style={{fontSize:13,fontWeight:700,color:"#1E293B",marginBottom:12}}>📅 Subscription</div>
        <div style={{fontSize:12,color:"#64748B",marginBottom:8}}>
          Valid until: <b style={{color:"#1E293B"}}>{c.valid_until||"Not set"}</b>
        </div>
        <div style={{marginBottom:10}}>
          <label style={{fontSize:11,color:"#64748B",display:"block",marginBottom:4}}>📅 Extend until date</label>
          <input type="date" value={extDate} onChange={e=>setExtDate(e.target.value)}
            min={new Date().toISOString().slice(0,10)}
            style={{width:"100%",padding:"8px 10px",borderRadius:8,border:"1px solid #E2E8F0",fontSize:13,boxSizing:"border-box"}}/>
        </div>
        <button onClick={extend}
          style={{width:"100%",padding:"9px",borderRadius:8,border:"none",background:"#7C3AED",color:"#fff",fontWeight:600,cursor:"pointer",fontSize:13}}>
          Set Subscription Date
        </button>
        <div style={{marginTop:10}}>
          <button onClick={()=>save({is_active:!c.is_active})}
            style={{width:"100%",padding:"9px",borderRadius:8,border:"none",fontWeight:600,cursor:"pointer",fontSize:13,
              background:c.is_active?"#FEE2E2":"#DCFCE7",color:c.is_active?"#DC2626":"#166534"}}>
            {c.is_active?"🔴 Deactivate Company":"🟢 Activate Company"}
          </button>
          <div style={{fontSize:11,color:"#94A3B8",marginTop:3,textAlign:"center"}}>
            {c.is_active?"Deactivating blocks all employee logins immediately":"Company is currently blocked"}
          </div>
        </div>
      </div>
    </div>

    {/* Logo upload */}
    <div style={{padding:"16px",background:"#F8FAFC",borderRadius:12,border:"1px solid #E2E8F0",marginBottom:16}}>
      <div style={{fontSize:13,fontWeight:700,color:"#1E293B",marginBottom:12}}>🖼 Company Logo (shown on login page)</div>
      <div style={{display:"flex",gap:12,alignItems:"center"}}>
        <label style={{cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6,
          background:"#F0FDF4",border:"1.5px dashed #0D9488",borderRadius:8,padding:"9px 16px",fontSize:13,color:"#0D9488",fontWeight:600}}>
          📁 Choose Logo
          <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>setLogo(e.target.files[0])}/>
        </label>
        {logo&&<img src={URL.createObjectURL(logo)} alt="" style={{height:40,borderRadius:6,objectFit:"contain",border:"1px solid #E2E8F0"}}/>}
        <button onClick={uploadLogo} disabled={!logo}
          style={{padding:"9px 20px",borderRadius:8,border:"none",background:logo?"#0D9488":"#E2E8F0",color:logo?"#fff":"#94A3B8",fontWeight:600,cursor:logo?"pointer":"not-allowed",fontSize:13}}>
          Upload Logo
        </button>
      </div>
    </div>

    {/* Plan features */}
    <div style={{marginBottom:16}}>
      <div style={{fontSize:12,color:"#64748B",fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",marginBottom:8}}>Plan Features ({c.plan})</div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
        {Object.entries(c.features||{}).map(([k,v])=>(
          <span key={k} style={{padding:"4px 12px",borderRadius:20,fontSize:12,fontWeight:600,
            background:v?"#DCFCE7":"#F1F5F9",color:v?"#166534":"#94A3B8"}}>{v?"✓":"✗"} {k}</span>
        ))}
      </div>
    </div>


    <EmployeesSection c={c}/>
    {/* Feature Toggles */}
    <FeatureToggles c={c} onSave={(feats)=>{
      sa.post(`/companies/${c.id}/features`,{features:feats})
        .then(r=>{ if(r.ok){setMsg("✓ Features saved");onRefresh();} else setMsg(r.detail||"Error"); });
    }}/>
    {msg&&<div style={{padding:"10px 14px",borderRadius:8,fontSize:13,fontWeight:500,
      background:msg.includes("✓")?"#DCFCE7":"#FEE2E2",color:msg.includes("✓")?"#166534":"#DC2626"}}>{msg}</div>}
  </div>;
}

// ── Main Dashboard ─────────────────────────────────────────────────────────
function Dashboard({admin,onLogout}){
  const [stats,   setStats]   = useState(null);
  const [cos,     setCos]     = useState([]);
  const [sel,     setSel]     = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [search,  setSearch]  = useState("");

  const load = () => {
    sa.get("/stats").then(d=>{ if(!d.detail) setStats(d); });
    sa.get("/companies").then(d=>{ if(d.companies) setCos(d.companies); });
  };
  useEffect(()=>load(),[]);

  const filtered = cos.filter(c=>`${c.name} ${c.code} ${c.email}`.toLowerCase().includes(search.toLowerCase()));
  const PC = {starter:"blue",growth:"purple",pro:"green"};

  return <div style={{minHeight:"100vh",background:"#F8FAFC",fontFamily:"system-ui,sans-serif"}}>
    {/* Header */}
    <div style={{background:"#0F172A",color:"#fff",padding:"14px 32px",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:100}}>
      <div style={{display:"flex",gap:12,alignItems:"center"}}>
        <span style={{fontWeight:800,letterSpacing:".2em",fontSize:16}}>INVINCIBLE</span>
        <span style={{color:"#334155",fontSize:13}}>· Platform Admin</span>
      </div>
      <div style={{display:"flex",gap:12,alignItems:"center"}}>
        <span style={{fontSize:13,color:"#64748B"}}>👤 {admin.username}</span>
        <button onClick={onLogout} style={{background:"#1E293B",border:"none",color:"#94A3B8",padding:"7px 16px",borderRadius:8,cursor:"pointer",fontSize:13}}>Logout</button>
      </div>
    </div>

    <div style={{maxWidth:1300,margin:"0 auto",padding:"28px 24px"}}>
      {/* Stats */}
      {stats&&<>
        <h2 style={{fontSize:20,fontWeight:700,marginBottom:16}}>Overview</h2>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:24}}>
          {[["Companies",stats.total_companies,"#1E293B","total"],["Active",stats.active_companies,"#0D9488","clients"],["Total Users",stats.total_users,"#1D4ED8","across all"],["MRR",fmt(stats.mrr),"#7C3AED","monthly recurring"]].map(([l,v,col,sub])=>(
            <div key={l} style={{background:"#fff",border:"1px solid #E2E8F0",borderRadius:12,padding:"18px 22px"}}>
              <div style={{fontSize:12,color:"#94A3B8",marginBottom:6,textTransform:"uppercase",letterSpacing:".06em"}}>{l}</div>
              <div style={{fontSize:28,fontWeight:700,color:col}}>{v}</div>
              <div style={{fontSize:12,color:"#CBD5E1",marginTop:3}}>{sub}</div>
            </div>
          ))}
        </div>
        {stats.expiring_soon?.length>0&&(
          <div style={{padding:"12px 18px",background:"#FEF3C7",borderRadius:10,marginBottom:20,border:"1px solid #FCD34D",fontSize:13,color:"#92400e"}}>
            ⚠ <b>Expiring soon:</b> {stats.expiring_soon.map(c=>`${c.name} (${c.days_left}d)`).join(" · ")}
          </div>
        )}
      </>}

      {/* Companies list */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <h3 style={{fontSize:16,fontWeight:700,margin:0}}>Client Companies ({filtered.length})</h3>
        <div style={{display:"flex",gap:10}}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search…"
            style={{padding:"9px 14px",borderRadius:9,border:"1px solid #E2E8F0",fontSize:13,width:240,outline:"none"}}/>
          <button onClick={()=>setShowAdd(true)}
            style={{padding:"10px 22px",borderRadius:9,border:"none",background:"#0D9488",color:"#fff",fontWeight:700,cursor:"pointer",fontSize:14}}>
            + Add Company
          </button>
        </div>
      </div>

      <div style={{background:"#fff",border:"1px solid #E2E8F0",borderRadius:14,overflow:"hidden",marginBottom:4}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:14}}>
          <thead><tr style={{background:"#F8FAFC"}}>
            {["","Code","Company","Plan","Seats","Bill/mo","Expires","Status",""].map((h,i)=>(
              <th key={i} style={{padding:"12px 16px",textAlign:"left",fontSize:11,fontWeight:700,color:"#64748B",borderBottom:"2px solid #E2E8F0",textTransform:"uppercase",letterSpacing:".06em"}}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {filtered.map(c=>(
              <tr key={c.id} onClick={()=>setSel(sel?.id===c.id?null:c)}
                style={{cursor:"pointer",background:sel?.id===c.id?"#F0FDF4":"#fff",borderBottom:"1px solid #F8FAFC",transition:"background .1s"}}>
                <td style={{padding:"10px 16px",width:44}}>
                  {c.has_logo
                    ?<img src={`${c.logo_url}?t=${c.id}`} alt="" style={{height:28,width:28,objectFit:"contain",borderRadius:6,border:"1px solid #E2E8F0"}}/>
                    :<div style={{width:28,height:28,borderRadius:6,background:"#0D9488",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:"#fff"}}>{c.code[0]}</div>
                  }
                </td>
                <td style={{padding:"10px 16px",fontWeight:700,color:"#0D9488"}}>{c.code}</td>
                <td style={{padding:"10px 16px"}}><b>{c.name}</b><br/><span style={{fontSize:12,color:"#94A3B8"}}>{c.email}</span></td>
                <td style={{padding:"10px 16px"}}><Pill t={c.plan} c={PC[c.plan]}/></td>
                <td style={{padding:"10px 16px"}}>
                  <span style={{fontWeight:700,fontSize:15,color:c.seats_available===0?"#DC2626":"#1E293B"}}>{c.seats_used}</span>
                  <span style={{color:"#CBD5E1",fontSize:13}}>/{c.max_seats}</span>
                  {c.seats_available===0&&<div style={{fontSize:10,color:"#DC2626",marginTop:1}}>FULL</div>}
                </td>
                <td style={{padding:"10px 16px",fontWeight:600}}>{fmt(c.monthly_bill)}</td>
                <td style={{padding:"10px 16px",fontSize:13}}>
                  {c.valid_until||"—"}
                  {c.days_left!=null&&<span style={{marginLeft:6,fontSize:11,fontWeight:700,color:c.days_left<=7?"#DC2626":c.days_left<=30?"#D97706":"#16A34A"}}>({c.days_left}d)</span>}
                </td>
                <td style={{padding:"10px 16px"}}>
                  <Pill t={!c.is_active?"Disabled":!c.is_subscription_active?"Expired":"Active"}
                    c={!c.is_active?"red":!c.is_subscription_active?"orange":"green"}/>
                </td>
                <td style={{padding:"10px 16px"}}>
                  <span style={{fontSize:12,color:"#94A3B8"}}>Click to manage →</span>
                </td>
              </tr>
            ))}
            {!filtered.length&&(
              <tr><td colSpan={9} style={{textAlign:"center",padding:48,color:"#94A3B8"}}>
                No companies yet. Click <b>"+ Add Company"</b> to onboard your first client.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Expanded detail */}
      {sel&&<CompanyDetail c={sel} onClose={()=>setSel(null)} onRefresh={()=>{load();setSel(null);}}/>}
    </div>

    {showAdd&&<AddModal onClose={()=>setShowAdd(false)} onDone={()=>{load();setShowAdd(false);}}/>}
  </div>;
}

// ── Root ───────────────────────────────────────────────────────────────────
export default function SuperAdminApp(){
  const [admin,setAdmin]=useState(null);
  useEffect(()=>{
    const t=sessionStorage.getItem("sa_token");
    if(t){ _t=t; sa.get("/stats").then(r=>{ if(!r.detail) setAdmin({username:"Super Admin"}); }).catch(()=>{}); }
  },[]);
  if(!admin) return <Login onLogin={r=>setAdmin({...r,username:r.username||"Super Admin"})}/>;
  return <Dashboard admin={admin} onLogout={()=>{ sessionStorage.removeItem("sa_token"); _t=""; setAdmin(null); }}/>;
}
